<script>
import { _request } from '@/helpers/_request'
import Parser from '@/helpers/_responseParser'

export default {
  name: 'OfferService',
  methods: {
    getOffers () {
      return _request('GetOffers').then(Parser.toXml.bind(null, 'GetOffersResponse'))
    },
    getOfferCode (TransactionRef) {
      return _request('GetOfferCode', { TransactionRef }).then(Parser.toXml.bind(null, 'GetOfferCodeResponse'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/services/OfferService.vue